import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useFrame } from '../contexts/FrameContext';
import ConfigurePanel from '../components/ConfigurePanel';

const CAROUSEL_IMAGES = [
  'https://qrmzfkvnksglemsiaxnp.supabase.co/storage/v1/object/public/website_assets//pic1.jpg',
  'https://qrmzfkvnksglemsiaxnp.supabase.co/storage/v1/object/public/website_assets//pic2.jpg',
  'https://qrmzfkvnksglemsiaxnp.supabase.co/storage/v1/object/public/website_assets//pic3.jpg',
  'https://qrmzfkvnksglemsiaxnp.supabase.co/storage/v1/object/public/website_assets//pic4.jpg'
];

const FramePreview: React.FC = () => {
  const navigate = useNavigate();
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const { propertyImage } = useFrame();

  useEffect(() => {
    const homeImageTimer = setInterval(() => {
      if (propertyImage) return; // Don't rotate if we have a property image
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % CAROUSEL_IMAGES.length);
    }, 3000);

    return () => clearInterval(homeImageTimer);
  }, [propertyImage]);

  return (
    <div className="min-h-screen bg-gray-100 relative">
      {/* Logo */}
      <div className="absolute top-8 left-1/2 -translate-x-1/2 z-50">
        <img 
          src="https://qrmzfkvnksglemsiaxnp.supabase.co/storage/v1/object/public/website_assets//Framemyhome.png"
          alt="Framemyhome"
          className="h-10 md:h-12"
        />
      </div>

      {/* Menu Button */}
      <button 
        onClick={() => setIsSidePanelOpen(!isSidePanelOpen)}
        className="absolute top-8 left-8 z-50 p-2 text-gray-700 hover:text-gray-900 transition-colors"
      >
        {isSidePanelOpen ? (
          <X className="w-6 h-6" />
        ) : (
          <Menu className="w-6 h-6" />
        )}
      </button>

      {/* Back Button */}
      <button 
        onClick={() => navigate('/')}
        className="absolute top-8 right-8 z-50 text-sm text-gray-700 hover:text-gray-900 transition-colors"
      >
        Back to Home
      </button>

      {/* Main Layout */}
      <div className="flex h-screen">
        {/* Configure Panel */}
        <ConfigurePanel
          isOpen={isSidePanelOpen}
          onClose={() => setIsSidePanelOpen(false)}
        />

        {/* Main Content Area */}
        <div className="flex-1 flex items-center justify-center">
          <div className="relative w-full max-w-4xl aspect-[4/3] px-6">
            <div className="absolute inset-[20%] z-0 overflow-hidden">
              {propertyImage ? (
                <img
                  src={propertyImage}
                  alt="Your property"
                  className="absolute inset-0 w-full h-full object-contain"
                />
              ) : (
                CAROUSEL_IMAGES.map((image, index) => (
                  <img
                    key={image}
                    src={image}
                    alt={`Carousel image ${index + 1}`}
                    className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-500 ${
                      index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                    }`}
                  />
                ))
              )}
            </div>
            <img
              src="https://qrmzfkvnksglemsiaxnp.supabase.co/storage/v1/object/public/Templates//Black_M.png"
              alt="Wooden Frame"
              className="absolute inset-0 w-full h-full object-contain z-10"
            />
            {!propertyImage && (
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20">
                <div className="flex gap-2">
                  {CAROUSEL_IMAGES.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`w-2 h-2 rounded-full transition-colors ${
                        index === currentImageIndex ? 'bg-black' : 'bg-gray-300 hover:bg-gray-400'
                      }`}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FramePreview;